export default __webpack_public_path__ + "static/ΠΡΟΣΥΜΒΑΤΙΚΗ_ΕΝΗΜΕΡΩΣΗ-b53e338572938ec1de71341bcf66deb0.pdf";